import Nav from "./Nav";
import AlertMessage from "../AlertMessage";
import { useAlert } from "../../context/AlertContext";
import { Box } from "@mui/material";
import { Colors } from "../../theme/colors";
import { useRTL } from "../../hooks/useLanguage/useRTL";

type IProps = {
  children: any;
};

const Layout: React.FC<IProps> = ({ children }) => {
  const { value, msg, setValue, error } = useAlert();
  const { isRTL } = useRTL();

  const dir = isRTL ? "rtl" : "ltr";
  return (
    <Box dir={dir}>
      <Nav />
      <Box sx={{ position: "relative", backgroundColor: Colors.background }}>
        {children}
      </Box>
      <AlertMessage value={value} setValue={setValue} error={error} msg={msg} />
    </Box>
  );
};

export default Layout;
